<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('tickettemplates') }}</div>
      <div>
        <!-- <router-link
          to
          @click.native="goToRoute('/master/edit-ticket-templates')"
          class="btn-blue"
        >{{ $t('edit') }}</router-link> -->
        <router-link
          class="btn-blue"
          to="ticket-templates"
        >{{ $t('tickettemplates') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="row justify-content-center">
        <div class="TempPreview" v-html="htmlData"></div>
      </div>
    </div>

    <!-- <div class="all-details-container">
      <div class="row mb-3">
        <div v-if="ticketDetails.temp_t_id == 1" class="col-md-12">
          <div class="row justify-content-center">
            <div
              class="mr-1"
              style="height:410px; width:104px; position:relative;"
              v-for="(x , xk) in 3"
              :key="xk"
            >
              <div
                class="print-tickets"
                style="transform: rotate(90deg);transform-origin: 52px 50%;"
              >
                <table border="0" style="width:410px;line-height:1; border:1px solid">
                  <tr>
                    <td colspan="3" style="padding:2px 10px;">
                      <table style="width:100%">
                        <tr>
                          <td style="vertical-align:top;">
                            <p style="font-size:18px;font-weight:600;margin:0">P</p>
                          </td>
                          <td>
                            <p style="font-size:14px;font-weight:600;margin: 0 0 5px 0">
                              <span>Cinema Name</span>
                              <span>(Address)</span>
                            </p>
                            <p
                              style="font-size:14px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                            >
                              <span>Movie Title</span>
                              <span
                                style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                              >Transaction No: 8765432190</span>
                            </p>
                            <span
                              style="font-size: 14px; margin: 0px 0px 5px;"
                            >Issued on: 17-Jan-2020 5:00:00 PM</span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:33.35%;padding: 2px 10px 2px 10px">
                      <p style="font-size:16px;font-weight:600;margin:0;">Total: 300 INR</p>
                    </td>
                    <td style="width:33.33%;padding:2px 10px 2px 10px;vertical-align:top;">
                      <p style="font-size:14px;font-weight:600;margin:0 0 5px 0;">Fri, 17-01-20</p>
                      <p style="font-size:14px;font-weight:600;margin:0 0 10px 0;">6:00 PM</p>
                    </td>
                    <td style="width:33.33%;padding:2px 10px 2px 10px;vertical-align:bottom">
                      <span>Seat Type:&nbsp;</span>
                      <span>Seat Name</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="ticketDetails.temp_t_id == 2" class="col-md-12 d-flex justify-content-center">
          <table style="width:302px;border:1px solid;font-size: 12px;padding: 10px 0;">
            <tr>
              <td colspan="2" style="text-align:center;font-size: 14px;">
                <strong>Cinema Name</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align:center;">
                <span>Cinema Address Here</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align:center;">
                <span>P.No. - 9022461985</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align:center;">
                <span>Email - support@cinema.com</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align:center;">
                <span>Transaction No: 1234567890</span>
              </td>
    </tr>-->
    <!-- TICKET SPACER -->
    <!-- <tr>
              <td colspan="2" style="padding: 10px;"></td>
            </tr>
            <tr>
              <td colspan="2" style="font-size: 14px;padding: 0 5px;">
                <strong>Movie Title</strong>
              </td>
            </tr>
            <tr>
              <td style="padding: 0 5px;">
                <span>Screen Name</span>
              </td>
              <td style="padding: 0 5px;">
                <span>Seat Type</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="padding: 0 5px;">
                Seat Name:
                <strong>J1, J2, J3, J4</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="padding: 0 5px;">
                <span>Show Date & Time</span>
              </td>
    </tr>-->
    <!-- TICKET SPACER -->
    <!-- <tr>
              <td colspan="2" style="padding: 10px;"></td>
    </tr>-->

    <!-- FNB BILLING -->
    <!-- <tr>
              <td style="width: 80%;padding: 0 5px;">
                <p style="margin-bottom: 0;">Pepsi</p>
                <p style="margin-bottom: 0;">Coke</p>
                <p style="margin-bottom: 0;">Burger</p>
              </td>
              <td style="width: 20%;padding: 0 5px;">
                <p style="margin-bottom: 0;">100</p>
                <p style="margin-bottom: 0;">100</p>
                <p style="margin-bottom: 0;">100</p>
              </td>
    </tr>-->
    <!-- MOVIE TICKETS BILLING -->
    <!-- <tr>
              <td style="width: 80%;padding: 0 5px;">
                <p style="margin-bottom: 0;">VAT (5%)</p>
                <p style="margin-bottom: 0;">GST</p>
              </td>
              <td style="width: 20%;padding: 0 5px;">
                <p style="margin-bottom: 0;">30</p>
                <p style="margin-bottom: 0;">10</p>
              </td>
    </tr>-->

    <!-- BILLING FINAL TOTAL -->
    <!-- <tr>
              <td colspan="2" style="padding: 5px;">
                <hr style="margin:0;" />
              </td>
            </tr>
            <tr>
              <td style="width: 80%;padding: 0 5px;">
                <strong>Total Amount</strong>
              </td>
              <td style="width: 20%;padding: 0 5px;">
                <strong>1000</strong>
              </td>
    </tr>-->

    <!-- TICKET SPACER -->
    <!-- <tr>
              <td colspan="2" style="padding: 10px;"></td>
            </tr>

            <tr>
              <td colspan="2" style="padding:5px;">
                <strong style="display: block;">Instructions</strong>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Assumenda aliquam quasi, totam minima similique eos
                iusto iste ratione, dolor ullam, laudantium perspiciatis enim. Beatae, odit quae! Fugit perspiciatis ex
                temporibus?
              </td>
            </tr>

            <tr>
              <td colspan="2" style="text-align: center;">
                <img src="@/assets/img/icons/Qr-4.png" height="50" width="50" alt="QR Code" />
              </td>
    </tr>-->

    <!-- TICKET SPACER -->
    <!-- <tr>
              <td colspan="2" style="padding: 10px;"></td>
            </tr>
          </table>
    </div>-->

    <!-- Third Template -->

    <!-- <div v-if="ticketDetails.temp_t_id == 3" class="col-md-12 d-flex justify-content-center">
          <table style="width:300px;border:1px solid #000;font-size:12px;">
            <tr>
              <td colspan="4" style="text-align:center;padding-top:20px;">
                <strong>MAS CINEMAS - IRAQ</strong>
                <p>Cinemas address</p>
              </td>
            </tr>

            <tr>
              <td colspan="4" style="padding-bottom:15px;">
                <table style="width:100%;text-align:center;">
                  <tr>
                    <td style="width:33.33%">
                      <p style="margin:0;">Transaction Id</p>
                      <strong>12345</strong>
                    </td>
                    <td style="width:33.33%">
                      <p style="margin:0;">Date</p>
                      <strong>23-01-2020</strong>
                    </td>
                    <td style="width:33.33%">
                      <p style="margin:0;">Time</p>
                      <strong>6:40pm</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td colspan="4" style="padding-bottom:15px;">
                <table style="width:100%;">
                  <tr>
                    <td style="width:70%;padding: 0 5px;">
                      <p style="margin:0;">Movie</p>
                      <strong>Avengers End Game</strong>
                    </td>
                    <td style="width:30%;padding: 0 5px;">
                      <p style="margin:0;">Cinema</p>
                      <strong>Screen 2</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr style="text-align:center;">
              <td style="width:25%;padding-bottom: 15px;">
                <p style="margin:0;">Restriction</p>
                <strong>18+</strong>
              </td>
              <td style="width:25%;padding-bottom: 15px;">
                <p style="margin:0;">Ticket</p>
                <strong>500</strong>
              </td>
              <td style="width:25%;padding-bottom: 15px;">
                <p style="margin:0;">VAT</p>
                <strong>00</strong>
              </td>
              <td style="width:25%;padding-bottom: 15px;">
                <p style="margin:0;">Total</p>
                <strong>500.00</strong>
              </td>
            </tr>

            <tr>
              <td colspan="4" style="padding-bottom:20px;">
                <table style="width:100%;">
                  <tr>
                    <td style="padding: 0 5px;">
                      <span style="margin:0;">Class:</span>
                      <strong>Normal</strong>
                    </td>
                    <td style="padding: 0 5px;">
                      <span style="margin:0;">Seats:</span>
                      <strong>E1, E2, E3,</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
    </div>-->
    <!-- </div> -->
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";

export default {
  data() {
    return {
      id: "",
      ticketDetails: {
        temp_t_id: "",
        temp_name: "",
        temp_active: "Y"
      },
      htmlData: null
    };
  },
  beforeMount() {
    const { t_id } = this.$route.query;
    this.id = t_id;
    this.GetTicektTemplateDetails(t_id);
  },

  methods: {
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: { t_id: this.id }
      });
    },

    GetTicektTemplateDetails: function(id) {
      let body = {
        temp_id: id,
        flag: "View"
      };

      MasterService.GetTicketTemplate(body).then(response => {
        console.log("response :", response);
        this.htmlData = response.data;
      });
    },
    // GetTicektTemplateDetails: function(id) {
    //   let body = {
    //     temp_id: id
    //   };
    //   MasterService.GetTicketTemplate(body).then(response => {
    //     const { data } = response;

    //     if (data.status) {
    //       if (data.Records && data.Records.length > 0) {
    //         let obj = data.Records[0];

    //         this.ticketDetails.temp_t_id = obj.t_id;
    //         this.ticketDetails.temp_name = obj.t_name;

    //         this.ticketDetails.temp_active = obj.tt_is_active;
    //       }
    //     }
    //   });
    // },

    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            if (cine_id === undefined) {
            } else {
              this.cinemaList.map(x => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.cinema_name = x.cine_name;
                  this.ticketDetails.temp_cinema_id = x.cine_id;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    }
  }
};
</script>


<style>
.bl-5 {
  border-left: 3px solid #000000;
}

.TempPreview table {
  border-collapse: unset !important;
}
</style>






// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketTemplates/viewTicketTemplates.vue